import type { FC, CSSProperties } from 'react';

import type { PutCartResponseDataCouponItemType } from '@/apis/product/index';

import type { CouponLimitListCardProps } from './Card';
import CouponLimitListCard from './Card';

export type CouponLimitListProps = {
  className?: string;
  style?: CSSProperties;
  items?: PutCartResponseDataCouponItemType[];
  onRemove?: CouponLimitListCardProps['onRemove'];
};

const CouponLimitList: FC<CouponLimitListProps> = (props) => {
  const { className, style, items, onRemove } = props;
  return (
    <div className={className} style={style}>
      {items?.map((i) => (
        <CouponLimitListCard key={i.couponId} item={i} onRemove={onRemove} />
      ))}
    </div>
  );
};

export default CouponLimitList;
